import Highcharts from 'highcharts'

export default function() {
	function createChart(obj) {
		const {items, container, maxVal} = obj

		let options = {     
			rangeSelector: {
				selected: 1
			},
			chart: {
				margin: [0, 0, 0, 0],
                spacingTop: 0,
                spacingRight: 0, 
                spacingBottom: 0,
                spacingLeft: 0,
                plotBorderWidth: 0,
				type: "areaspline"
			},
			title: {
				text:''
			},
			legend: {
				enabled: false
			},
			xAxis: {
				visible: false,
				type: 'datetime',
                minPadding:0,
                maxPadding:0
			},
			yAxis: {
				min: items[0][1] - maxVal,
				max: maxVal,
				visible: false,
			},
			credits: {
				enabled: false
			},
			plotOptions: {
				areaspline: {
                    threshold: null,
					fillColor: {
						linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
						stops: [
						  [0, 'rgba(54, 146, 254, 0.2)'],
						  [1, 'rgba(54, 146, 254, 0)']
						]
					},
					fillOpacity: 0.2
				},
				series: {
					enableMouseTracking: false,
					states: {
						inactive: {
							opacity: 1
						}
					},
					events: {
						legendItemClick: function() {
							return false
						}
					},
					marker: {
						enabled: false
					}
				}
			},
			tooltip: {
				enabled: false
			},
    
			series: [{
				data: items,
				type: 'areaspline',
				color: '#3692FE',
				lineWidth: 1
			}]
		}

		Highcharts.chart(container, options)
	}
	function renderChart(coin, container) {
		// console.log(coin)
		// coin = coin.replace('ERC20', '')

		let url = `https://raki.atomicwallet.io/last24Hour?fiat=USD&tickers=${coin}`
		fetch(url)
			.then((response) => {
				return response.json()
			})
			.then((dataJson) => {
				let arr = dataJson[coin]
				let items = []
				for(let i = 0; i < arr.length; i++) {
					if(!(i % 24)) {
						var time = Date.parse(arr[i].time)
						let itemInfo = []
						itemInfo.push(+time, arr[i].close)
						items.push(itemInfo)
					}
				}

				let firstVal = items[0][1]

				items = items.map(item => {
					item[1] = item[1] - firstVal

					return item
				})
				

				let itemsVals = items.map(item => {
					return item[1]
				})
				let minVal = Math.min(...itemsVals)
				let maxVal = Math.max(...itemsVals)

				if ( Math.abs(minVal) > Math.abs(maxVal) ) maxVal = Math.abs(minVal)
                
				createChart({
					items,
					container,
					maxVal
				})
			})
			.catch(err => {
				console.log(err)
				renderChart("BTC", container)
			})
	}
	let tickers = document.querySelectorAll('.ticker')
	tickers.forEach(function(item) {
		let coin = item.getAttribute('data-coin');
		if(coin === "USDTERC20" || coin === "USDTTRC20") {
			coin = "USDT"
		}
		let container = item.querySelector('.ticker__chart')
		renderChart(coin, container)
	})
}